import { Plugin } from '@nuxt/types'
import * as config from '@/config'

const plugin: Plugin = (context, inject) => {
  inject('config', config)
}

export default plugin
